const CHUNK_LOAD_ERROR_PATTERNS = [
    "failed to fetch dynamically imported module",
    "importing a module script failed",
    "error loading dynamically imported module",
];

export const isChunkLoadError = (error: unknown): boolean => {
    if (!(error instanceof Error)) return false;
    const message = error.message.toLowerCase();
    return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => message.includes(pattern));
};

const reloadOnceForStaleAssets = (): void => {
    const reloadKey = "elitphone-chunk-reload";
    if (sessionStorage.getItem(reloadKey)) return;
    sessionStorage.setItem(reloadKey, "1");
    window.location.reload();
};

export const registerChunkLoadErrorRecovery = (): void => {
    window.addEventListener("vite:preloadError", (event) => {
        event.preventDefault();
        reloadOnceForStaleAssets();
    });

    window.addEventListener("unhandledrejection", (event) => {
        if (!isChunkLoadError(event.reason)) return;
        event.preventDefault();
        reloadOnceForStaleAssets();
    });
};
